/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NormativeDocumentVersionIncludeFilterInner } from './normativeDocumentVersionIncludeFilterInner';
import { NormativeDocumentVersionFields } from './normativeDocumentVersionFields';
import { AcademicLevelFilterOrder } from './academicLevelFilterOrder';


export interface NormativeDocumentVersionFilter { 
    offset?: number;
    limit?: number;
    skip?: number;
    order?: AcademicLevelFilterOrder;
    where?: { [key: string]: any; };
    fields?: NormativeDocumentVersionFields;
    include?: Array<NormativeDocumentVersionIncludeFilterInner>;
}

